'use client';

import type { FC } from 'react';

import { useCssDimensions } from '@/utils/hooks/useCssDimensions';

import {
    LocalImage,
    type LocalImageProps,
} from '@/components/atoms/LocalImage';
import H2 from '@/components/atoms/Typography/H2';
import { Title } from '@/components/atoms/Typography/Title';
import IconsLinksList, {
    type IconsLinksListProps,
} from '@/components/molecules/IconsLinksList/IconsLinksList';

export interface QRCodeTemplateProps {
    title: string;
    subtitle: string;
    imageQR: LocalImageProps;
    storeButtons: IconsLinksListProps['iconsData'];
}

const QRCodeTemplate: FC<QRCodeTemplateProps> = ({
    title,
    subtitle,
    imageQR,
    storeButtons,
}) => {
    const { minWidthXl } = useCssDimensions();

    return (
        <>
            <H2 className="heading-spaces text-center">{title}</H2>

            {minWidthXl ? (
                <>
                    <Title
                        size="l"
                        className="mb-4 text-center"
                    >
                        {subtitle}
                    </Title>

                    <div className="mx-auto w-max rounded-lg border border-gray-200 p-[2px] shadow-xl">
                        <LocalImage
                            width={148}
                            height={148}
                            {...imageQR}
                        />
                    </div>
                </>
            ) : (
                <IconsLinksList
                    variant="horizontal"
                    className="mt-8"
                    iconsData={storeButtons}
                />
            )}
        </>
    );
};

export default QRCodeTemplate;
